import * as i0 from '@angular/core';
import { Injectable, NgModule, Optional, SkipSelf, APP_INITIALIZER } from '@angular/core';
import * as i2 from '@angular/common/http';
import { HttpParams, HttpHeaders, HttpRequest, HttpResponse, HttpErrorResponse, HttpEventType, HTTP_INTERCEPTORS } from '@angular/common/http';
import { filter, map, tap } from 'rxjs/operators';

/* tslint:disable */
/* eslint-disable */
var LogType;
(function (LogType) {
    LogType["Debug"] = "DEBUG";
    LogType["Info"] = "INFO";
    LogType["Warn"] = "WARN";
    LogType["Error"] = "ERROR";
})(LogType || (LogType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * Global configuration
 */
class ApiConfiguration {
    rootUrl = '';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiConfiguration, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiConfiguration, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiConfiguration, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/* tslint:disable */
/* eslint-disable */
/**
 * Base class for services
 */
class BaseService {
    config;
    http;
    constructor(config, http) {
        this.config = config;
        this.http = http;
    }
    _rootUrl = '';
    /**
     * Returns the root url for all operations in this service. If not set directly in this
     * service, will fallback to `ApiConfiguration.rootUrl`.
     */
    get rootUrl() {
        return this._rootUrl || this.config.rootUrl;
    }
    /**
     * Sets the root URL for API operations in this service.
     */
    set rootUrl(rootUrl) {
        this._rootUrl = rootUrl;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseService, deps: [{ token: ApiConfiguration }, { token: i2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: ApiConfiguration }, { type: i2.HttpClient }]; } });

/* tslint:disable */
/* eslint-disable */
/**
 * Custom parameter codec to correctly handle the plus sign in parameter
 * values. See https://github.com/angular/angular/issues/18261
 */
class ParameterCodec {
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    encodeValue(value) {
        return encodeURIComponent(value);
    }
    decodeKey(key) {
        return decodeURIComponent(key);
    }
    decodeValue(value) {
        return decodeURIComponent(value);
    }
}
const ParameterCodecInstance = new ParameterCodec();
/**
 * Base class for a parameter
 */
class Parameter {
    name;
    value;
    options;
    constructor(name, value, options, defaultStyle, defaultExplode) {
        this.name = name;
        this.value = value;
        this.options = options;
        this.options = options || {};
        if (this.options.style === null || this.options.style === undefined) {
            this.options.style = defaultStyle;
        }
        if (this.options.explode === null || this.options.explode === undefined) {
            this.options.explode = defaultExplode;
        }
    }
    serializeValue(value, separator = ',') {
        if (value === null || value === undefined) {
            return '';
        }
        else if (value instanceof Array) {
            return value.map(v => this.serializeValue(v).split(separator).join(encodeURIComponent(separator))).join(separator);
        }
        else if (typeof value === 'object') {
            const array = [];
            for (const key of Object.keys(value)) {
                let propVal = value[key];
                if (propVal !== null && propVal !== undefined) {
                    propVal = this.serializeValue(propVal).split(separator).join(encodeURIComponent(separator));
                    if (this.options.explode) {
                        array.push(`${key}=${propVal}`);
                    }
                    else {
                        array.push(key);
                        array.push(propVal);
                    }
                }
            }
            return array.join(separator);
        }
        else {
            return String(value);
        }
    }
}
/**
 * A parameter in the operation path
 */
class PathParameter extends Parameter {
    constructor(name, value, options) {
        super(name, value, options, 'simple', false);
    }
    append(path) {
        let value = this.value;
        if (value === null || value === undefined) {
            value = '';
        }
        let prefix = this.options.style === 'label' ? '.' : '';
        let separator = this.options.explode ? prefix === '' ? ',' : prefix : ',';
        let alreadySerialized = false;
        if (this.options.style === 'matrix') {
            // The parameter name is just used as prefix, except in some cases...
            prefix = `;${this.name}=`;
            if (this.options.explode && typeof value === 'object') {
                prefix = ';';
                if (value instanceof Array) {
                    // For arrays we have to repeat the name for each element
                    value = value.map(v => `${this.name}=${this.serializeValue(v, ';')}`);
                    value = value.join(';');
                    alreadySerialized = true;
                }
                else {
                    // For objects we have to put each the key / value pairs
                    value = this.serializeValue(value, ';');
                    alreadySerialized = true;
                }
            }
        }
        value = prefix + (alreadySerialized ? value : this.serializeValue(value, separator));
        // Replace both the plain variable and the corresponding variant taking in the prefix and explode into account
        path = path.replace(`{${this.name}}`, value);
        path = path.replace(`{${prefix}${this.name}${this.options.explode ? '*' : ''}}`, value);
        return path;
    }
    // @ts-ignore
    serializeValue(value, separator = ',') {
        var result = typeof value === 'string' ? encodeURIComponent(value) : super.serializeValue(value, separator);
        result = result.replace(/%3D/g, '=');
        result = result.replace(/%3B/g, ';');
        result = result.replace(/%2C/g, ',');
        return result;
    }
}
/**
 * A parameter in the query
 */
class QueryParameter extends Parameter {
    constructor(name, value, options) {
        super(name, value, options, 'form', true);
    }
    append(params) {
        if (this.value instanceof Array) {
            // Array serialization
            if (this.options.explode) {
                for (const v of this.value) {
                    params = params.append(this.name, this.serializeValue(v));
                }
            }
            else {
                const separator = this.options.style === 'spaceDelimited'
                    ? ' ' : this.options.style === 'pipeDelimited'
                    ? '|' : ',';
                return params.append(this.name, this.serializeValue(this.value, separator));
            }
        }
        else if (this.value !== null && typeof this.value === 'object') {
            // Object serialization
            if (this.options.style === 'deepObject') {
                // Append a parameter for each key, in the form `name[key]`
                for (const key of Object.keys(this.value)) {
                    const propVal = this.value[key];
                    if (propVal !== null && propVal !== undefined) {
                        params = params.append(`${this.name}[${key}]`, this.serializeValue(propVal));
                    }
                }
            }
            else if (this.options.explode) {
                // Append a parameter for each key without using the parameter name
                for (const key of Object.keys(this.value)) {
                    const propVal = this.value[key];
                    if (propVal !== null && propVal !== undefined) {
                        params = params.append(key, this.serializeValue(propVal));
                    }
                }
            }
            else {
                // Append a single parameter whose values are a comma-separated list of key,value,key,value...
                const array = [];
                for (const key of Object.keys(this.value)) {
                    const propVal = this.value[key];
                    if (propVal !== null && propVal !== undefined) {
                        array.push(key);
                        array.push(propVal);
                    }
                }
                params = params.append(this.name, this.serializeValue(array));
            }
        }
        else if (this.value !== null && this.value !== undefined) {
            // Plain value
            params = params.append(this.name, this.serializeValue(this.value));
        }
        return params;
    }
}
/**
 * A parameter in the HTTP request header
 */
class HeaderParameter extends Parameter {
    constructor(name, value, options) {
        super(name, value, options, 'simple', false);
    }
    append(headers) {
        if (this.value !== null && this.value !== undefined) {
            if (this.value instanceof Array) {
                for (const v of this.value) {
                    headers = headers.append(this.name, this.serializeValue(v));
                }
            }
            else {
                headers = headers.append(this.name, this.serializeValue(this.value));
            }
        }
        return headers;
    }
}
/**
 * Helper to build http requests from parameters
 */
class RequestBuilder {
    rootUrl;
    operationPath;
    method;
    _path = new Map();
    _query = new Map();
    _header = new Map();
    _bodyContent;
    _bodyContentType;
    constructor(rootUrl, operationPath, method) {
        this.rootUrl = rootUrl;
        this.operationPath = operationPath;
        this.method = method;
    }
    /**
     * Sets a path parameter
     */
    path(name, value, options) {
        this._path.set(name, new PathParameter(name, value, options || {}));
    }
    /**
     * Sets a query parameter
     */
    query(name, value, options) {
        this._query.set(name, new QueryParameter(name, value, options || {}));
    }
    /**
     * Sets a header parameter
     */
    header(name, value, options) {
        this._header.set(name, new HeaderParameter(name, value, options || {}));
    }
    /**
     * Sets the body content, along with the content type
     */
    body(value, contentType = 'application/json') {
        if (value instanceof Blob) {
            this._bodyContentType = value.type;
        }
        else {
            this._bodyContentType = contentType;
        }
        if (this._bodyContentType === 'application/x-www-form-urlencoded' && value !== null && typeof value === 'object') {
            // Handle URL-encoded data
            const pairs = [];
            for (const key of Object.keys(value)) {
                let val = value[key];
                if (!(val instanceof Array)) {
                    val = [val];
                }
                for (const v of val) {
                    const formValue = this.formDataValue(v);
                    if (formValue !== null) {
                        pairs.push([key, formValue]);
                    }
                }
            }
            this._bodyContent = pairs.map(p => `${encodeURIComponent(p[0])}=${encodeURIComponent(p[1])}`).join('&');
        }
        else if (this._bodyContentType === 'multipart/form-data') {
            // Handle multipart form data
            const formData = new FormData();
            if (value !== null && value !== undefined) {
                for (const key of Object.keys(value)) {
                    const val = value[key];
                    if (val instanceof Array) {
                        for (const v of val) {
                            const toAppend = this.formDataValue(v);
                            if (toAppend !== null) {
                                formData.append(key, toAppend);
                            }
                        }
                    }
                    else {
                        const toAppend = this.formDataValue(val);
                        if (toAppend !== null) {
                            formData.set(key, toAppend);
                        }
                    }
                }
            }
            this._bodyContent = formData;
        }
        else {
            // The body is the plain content
            this._bodyContent = value;
        }
    }
    formDataValue(value) {
        if (value === null || value === undefined) {
            return null;
        }
        if (value instanceof Blob) {
            return value;
        }
        if (typeof value === 'object') {
            return JSON.stringify(value);
        }
        return String(value);
    }
    /**
     * Builds the request with the current set parameters
     */
    build(options) {
        options = options || {};
        // Path parameters
        let path = this.operationPath;
        for (const pathParam of this._path.values()) {
            path = pathParam.append(path);
        }
        const url = this.rootUrl + path;
        // Query parameters
        let httpParams = new HttpParams({
            encoder: ParameterCodecInstance
        });
        for (const queryParam of this._query.values()) {
            httpParams = queryParam.append(httpParams);
        }
        // Header parameters
        let httpHeaders = new HttpHeaders();
        if (options.accept) {
            httpHeaders = httpHeaders.append('Accept', options.accept);
        }
        for (const headerParam of this._header.values()) {
            httpHeaders = headerParam.append(httpHeaders);
        }
        // Request content headers
        if (this._bodyContentType && !(this._bodyContent instanceof FormData)) {
            httpHeaders = httpHeaders.set('Content-Type', this._bodyContentType);
        }
        // Perform the request
        return new HttpRequest(this.method.toUpperCase(), url, this._bodyContent, {
            params: httpParams,
            headers: httpHeaders,
            responseType: options.responseType,
            reportProgress: options.reportProgress,
            context: options.context
        });
    }
}

/* tslint:disable */
/* eslint-disable */
class BackendLoggingService extends BaseService {
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Path part for operation loggingLogPost
     */
    static LoggingLogPostPath = '/logging/log';
    /**
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `loggingLogPost()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    loggingLogPost$Response(params) {
        const rb = new RequestBuilder(this.rootUrl, BackendLoggingService.LoggingLogPostPath, 'post');
        if (params) {
            rb.body(params.body, 'application/json');
        }
        return this.http.request(rb.build({
            responseType: 'text',
            accept: '*/*',
            context: params?.context
        })).pipe(filter((r) => r instanceof HttpResponse), map((r) => {
            return r.clone({ body: undefined });
        }));
    }
    /**
     * This method provides access to only to the response body.
     * To access the full response (for headers, for example), `loggingLogPost$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    loggingLogPost(params) {
        return this.loggingLogPost$Response(params).pipe(map((r) => r.body));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BackendLoggingService, deps: [{ token: ApiConfiguration }, { token: i2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BackendLoggingService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BackendLoggingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: ApiConfiguration }, { type: i2.HttpClient }]; } });

class LoggingService {
    logService;
    static CORRELATION_ID_KEY = 'correlationId';
    mdcVarsConstants = this.getStandardMdc();
    mdcVars = new Map();
    correlationID;
    messageCache = new Set();
    constructor(logService) {
        this.logService = logService;
    }
    init() {
        //In order to use the non-overridden debug and error functions when reporting on success or errors in the REST service, we save a version of them here
        const debugFunction = console.debug;
        const errorFunction = console.error;
        //Override the logging functions with a function that will also call the rest service.
        console.info = this.overrideFunction(LogType.Info, console.info, debugFunction, errorFunction);
        console.error = this.overrideFunction(LogType.Error, console.error, debugFunction, errorFunction);
        console.debug = this.overrideFunction(LogType.Debug, console.debug, debugFunction, errorFunction);
        console.warn = this.overrideFunction(LogType.Warn, console.warn, debugFunction, errorFunction);
    }
    setCorrelationID(correlationID) {
        if (!this.correlationID) {
            this.overrideCorrelationID(correlationID);
        }
    }
    overrideCorrelationID(correlationID) {
        this.correlationID = correlationID;
    }
    getCorrelationID() {
        return this.correlationID;
    }
    addMDC(key, value) {
        this.mdcVars.set(key, value);
    }
    removeMDC(key) {
        this.mdcVars.delete(key);
    }
    getMDC(debug, error) {
        const mdc = [...this.mdcVarsConstants];
        try {
            for (const key of this.mdcVars.keys()) {
                mdc.push({ key: key, value: this.mdcVars.get(key) });
            }
        }
        catch (e) {
            error('Failed to push MDC Vars', this.correlationID, e);
        }
        try {
            mdc.push({ key: "screenY", value: window.screenY + '' });
            mdc.push({ key: "screenX", value: window.screenX + '' });
            mdc.push({ key: "innerHeight", value: window.innerHeight + '' });
            mdc.push({ key: "innerWidth", value: window.innerWidth + '' });
            if (window.screen?.orientation?.type) {
                mdc.push({ key: "orientation", value: window.screen.orientation.type + '' });
            }
            if (window.location?.href) {
                mdc.push({ key: "href", value: window.location.href });
            }
            // @ts-ignore
            if (window.navigator?.connection?.type) {
                // @ts-ignore
                mdc.push({ key: "connection", value: window.navigator.connection.type });
            }
        }
        catch (e) {
            error('Could not set MDC', this.correlationID, e);
        }
        if (this.correlationID) {
            mdc.push({ key: LoggingService.CORRELATION_ID_KEY, value: this.correlationID });
        }
        return mdc;
    }
    getStandardMdc() {
        const mdcVars = new Array();
        if (window.navigator?.userAgent) {
            mdcVars.push({ key: "userAgent", value: window.navigator.userAgent });
        }
        if (window.navigator?.vendor) {
            mdcVars.push({ key: "vendor", value: window.navigator.vendor });
        }
        if (window.navigator?.language) {
            mdcVars.push({ key: "language", value: window.navigator.language });
        }
        return mdcVars;
    }
    isMdcVar(item) {
        if (item === undefined || item === null) {
            return false;
        }
        const castItem = item;
        return castItem.key !== undefined && castItem.value !== undefined;
    }
    //Return a new function based on the passed function, that will call the original function, as well as send the data via REST. The error and debug functions
    //are the original non-overriden functions, to now end up in an infinite loop.
    overrideFunction(type, originalFunction, debug, error) {
        const overriddenFunction = (...data) => {
            originalFunction(...data);
            this.sendLogMessage(type, data, debug, error);
        };
        return overriddenFunction;
    }
    sendLogMessage(type, data, debug, error) {
        try {
            let logText;
            let mdc = this.getMDC(debug, error);
            let otherObjects = new Array();
            data.forEach((value, index) => {
                try {
                    if (index === 0 && typeof value === 'string') {
                        logText = value;
                    }
                    else if (this.isMdcVar(value)) {
                        mdc.push(value);
                    }
                    else if (value instanceof Error) {
                        //Replace the generic "ERROR" message from root-level catch with the error message
                        if (logText === "ERROR" && value.message) {
                            logText = value.message;
                        }
                        otherObjects.push(this.jsonStringifyError(value));
                    }
                    else if (value instanceof HttpErrorResponse) {
                        if (logText === "ERROR" && value.message) {
                            logText = value.message;
                        }
                        otherObjects.push(this.jsonStringify(value));
                    }
                    else {
                        otherObjects.push(this.jsonStringify(value));
                    }
                }
                catch (e) {
                    error("Could not format log message", e, value);
                }
            });
            if (this.shouldSendMessage(type, logText, otherObjects)) {
                this.logService.loggingLogPost({ body: { logType: type, text: logText, mdc: mdc, objects: otherObjects } }).subscribe(() => { }, () => { error("Failed sending " + type, logText, mdc, ...otherObjects); });
            }
        }
        catch (e) {
            error("Could not send log message", ...data, e);
        }
    }
    shouldSendMessage(type, text, objects) {
        if (type !== LogType.Error) {
            return true;
        }
        if (!text) {
            text = "";
        }
        if (objects) {
            text = text.concat(...objects);
        }
        const hash = this.hashCode(text);
        if (this.messageCache.has(hash)) {
            return false;
        }
        else {
            this.messageCache.add(hash);
            return true;
        }
    }
    hashCode(str) {
        let h = 0, l = str.length, i = 0;
        if (l > 0)
            while (i < l)
                h = (h << 5) - h + str.charCodeAt(i++) | 0;
        return h;
    }
    /**
     * This method can stringify objects with cyclic object value. (A references to itself)
     * */
    jsonStringify(data) {
        const seen = new WeakSet();
        const toJson = JSON.stringify(data, (key, value) => {
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) {
                    // This is just to indicate a cyclic reference
                    return "[Circular]";
                }
                seen.add(value);
            }
            return value;
        });
        return toJson;
    }
    /**
     * To ensure non-enumerable properties is included from an Error object
     * */
    jsonStringifyError(data) {
        const errorObj = {
            // @ts-ignore
            name: data.name,
            // @ts-ignore
            message: data.message,
            stack: data.stack,
            // Spread the rest of the enumerable properties (if any) from the error instance
            ...data
        };
        return this.jsonStringify(errorObj);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoggingService, deps: [{ token: BackendLoggingService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoggingService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoggingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: BackendLoggingService }]; } });

class FrontendLoggingApiConfiguration {
    urlWhitelist = [];
    urlBlacklist = [];
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FrontendLoggingApiConfiguration, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FrontendLoggingApiConfiguration, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FrontendLoggingApiConfiguration, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class CorrelationIdInterceptor {
    loggingService;
    config;
    constructor(loggingService, config) {
        this.loggingService = loggingService;
        this.config = config;
    }
    intercept(httpRequest, next) {
        const correlationID = this.loggingService.getCorrelationID();
        const url = httpRequest.url;
        if (correlationID) {
            let hasWhitelist = false;
            let hasBlacklist = false;
            let isOnWhitelist = false;
            let isOnBlacklist = false;
            if (this.config.urlWhitelist) {
                this.config.urlWhitelist.forEach(value => {
                    hasWhitelist = true;
                    if (url.startsWith(value)) {
                        isOnWhitelist = true;
                    }
                });
            }
            if (this.config.urlBlacklist) {
                this.config.urlBlacklist.forEach(value => {
                    hasBlacklist = true;
                    if (url.startsWith(value)) {
                        isOnBlacklist = true;
                    }
                });
            }
            //if the url is blacklisted, do not add correlationID no matter what
            if (hasBlacklist && isOnBlacklist) {
                return next.handle(httpRequest);
            }
            //if a whitelist is configured, only add correlationID if the url is whitelisted, if no whitelist is found then add correlationID
            if (hasWhitelist && !isOnWhitelist) {
                return next.handle(httpRequest);
            }
            const headers = {};
            headers[LoggingService.CORRELATION_ID_KEY] = correlationID;
            httpRequest = httpRequest.clone({ setHeaders: headers });
        }
        return next.handle(httpRequest).pipe(tap(event => {
            if (event.type === HttpEventType.Response) {
                if (event.headers.has(LoggingService.CORRELATION_ID_KEY)) {
                    const correlationID = event.headers.get(LoggingService.CORRELATION_ID_KEY);
                    if (correlationID) {
                        this.loggingService.setCorrelationID(correlationID);
                    }
                }
            }
        }));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CorrelationIdInterceptor, deps: [{ token: LoggingService }, { token: FrontendLoggingApiConfiguration }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CorrelationIdInterceptor });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CorrelationIdInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: LoggingService }, { type: FrontendLoggingApiConfiguration }]; } });

/* tslint:disable */
/* eslint-disable */
/**
 * Module that provides all services and configuration.
 */
class ApiModule {
    static forRoot(params) {
        return {
            ngModule: ApiModule,
            providers: [
                {
                    provide: ApiConfiguration,
                    useValue: params
                }
            ]
        };
    }
    constructor(parentModule, http) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
                'See also https://github.com/angular/angular/issues/20575');
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiModule, deps: [{ token: ApiModule, optional: true, skipSelf: true }, { token: i2.HttpClient, optional: true }], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApiModule });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiModule, providers: [
            BackendLoggingService,
            ApiConfiguration
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [],
                    declarations: [],
                    providers: [
                        BackendLoggingService,
                        ApiConfiguration
                    ],
                }]
        }], ctorParameters: function () { return [{ type: ApiModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }, { type: i2.HttpClient, decorators: [{
                    type: Optional
                }] }]; } });

class FrontendLoggingModule {
    static forRoot(apiParams, frontendParams) {
        return {
            ngModule: FrontendLoggingModule,
            providers: [
                {
                    provide: ApiConfiguration,
                    useValue: apiParams
                },
                {
                    provide: FrontendLoggingApiConfiguration,
                    useValue: frontendParams
                }
            ]
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FrontendLoggingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FrontendLoggingModule, imports: [ApiModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FrontendLoggingModule, providers: [
            LoggingService,
            FrontendLoggingApiConfiguration,
            { provide: HTTP_INTERCEPTORS, useClass: CorrelationIdInterceptor, deps: [LoggingService, FrontendLoggingApiConfiguration], multi: true },
            {
                provide: APP_INITIALIZER,
                useFactory: initiateLogService,
                deps: [LoggingService],
                multi: true
            }
        ], imports: [ApiModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FrontendLoggingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        ApiModule
                    ],
                    exports: [],
                    providers: [
                        LoggingService,
                        FrontendLoggingApiConfiguration,
                        { provide: HTTP_INTERCEPTORS, useClass: CorrelationIdInterceptor, deps: [LoggingService, FrontendLoggingApiConfiguration], multi: true },
                        {
                            provide: APP_INITIALIZER,
                            useFactory: initiateLogService,
                            deps: [LoggingService],
                            multi: true
                        }
                    ],
                }]
        }] });
function initiateLogService(loggingService) {
    return () => {
        return new Promise((resolve) => {
            loggingService.init();
            resolve();
        });
    };
}

/*
 * Public API Surface of frontend-logging
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApiModule, BackendLoggingService, FrontendLoggingModule, LoggingService, initiateLogService };
